angular
	.module 'App.Repository'
	.factory 'ShopVisitorCountRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class ShopVisitorCountRepository extends BaseRepository
				@resource = '/shop_visitor_counts'
				@isRestricted = true

			return new ShopVisitorCountRepository
	]
